export var ContractOnboardingType;
(function (ContractOnboardingType) {
    ContractOnboardingType["KLARNA_POINT_OF_SALES"] = "KLARNA_POINT_OF_SALES";
    ContractOnboardingType["MANAGED_MERCHANT_IN_STORE"] = "MANAGED_MERCHANT_IN_STORE";
    ContractOnboardingType["MEDIA"] = "MEDIA";
    ContractOnboardingType["SEARCH_AND_COMPARE"] = "SEARCH_AND_COMPARE";
    ContractOnboardingType["UPSELL_WEBSTORE_TO_ADS_MANAGER"] = "UPSELL_WEBSTORE_TO_ADS_MANAGER";
    ContractOnboardingType["UPSELL_WEBSTORE_TO_CONTENT_MANAGER"] = "UPSELL_WEBSTORE_TO_CONTENT_MANAGER";
    ContractOnboardingType["UPSELL_WEBSTORE_TO_KPOS"] = "UPSELL_WEBSTORE_TO_KPOS";
    ContractOnboardingType["UPSELL_WEBSTORE_TO_PRICERUNNER"] = "UPSELL_WEBSTORE_TO_PRICERUNNER";
    ContractOnboardingType["UPSELL_WEBSTORE_TO_VIRTUAL_SHOPPING"] = "UPSELL_WEBSTORE_TO_VIRTUAL_SHOPPING";
})(ContractOnboardingType || (ContractOnboardingType = {}));
